import { ca } from '@cian/analytics';
import { EServiceId } from '../../../../../../types/reducers/publishTerms';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../../../types/analytics';

interface ITrackPackageSelectParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  packageServiceId: EServiceId;
}

export const trackPackageSelect = (params: ITrackPackageSelectParams) => {
  const { analyticsOfferStatus, analyticsProduct, packageServiceId } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: 'publication_pack',
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest_webview',
        publication_type: packageServiceId,
      },
    },
  });
};
